import { Div } from "@tblabs/truffle";
import { Router } from "../Services/Router";
import { Icons } from "./Utils/Icons";
import { XPrimaryButton, XSecondaryButton } from "./Utils/XPrimaryButton";
import { OnlineStorage } from "@tblabs/storage";
import { UserSection } from "./UserSection";


export class TopPanel extends Div
{
    constructor(_storage: OnlineStorage, _router: Router)
    {
        super("header");

        this.Append(
            new Div("header__container").Append(
                new Div("header__content").Append(
                    new Div("header__buttons").Append(
                        new XSecondaryButton("Zamówienia", Icons.List).OnClick(() => _router.GoToOrdersList()),
                        new XPrimaryButton("Dodaj", Icons.Plus).OnClick(() => _router.GoToOrderCreate())
                    ),
                    new UserSection(_storage, _router),
                )
            )
        );
    }
}
